import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'ResourcesSection' })((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 64,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            gap: 40
        }
    },
    cards: {
        gap: 20,
        width: '100%',
        display: 'grid',
        gridTemplateRows: '1fr',
        gridTemplateColumns: 'repeat(8, 1fr)',
        ['& > *']: {
            gridColumnEnd: 'span 2'
        },
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            overflowX: 'auto',
            scrollbarWidth: 'none',
            gridTemplateColumns: 'repeat(8, 1fr)',
            ['&& > *']: {
                gridColumnStart: 'auto',
                gridColumnEnd: 'auto'
            },
            '&::-webkit-scrollbar': {
                display: 'none'
            }
        }
    },
    card: {
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            minWidth: 215
        }
    }
}));
